<template>
  <div class="text-xs-center">
    <v-layout>
      <template v-if="!['depa'].includes(selectedBot.theme)">
        <v-flex style="position: relative">
          <v-btn
            depressed
            style="border-radius: 0; width: 100%"
            class="ma-0"
            :color="$store.state.livechat.app == 'facebook' ? 'primary' : 'grey'"
            @click="changeApp('facebook')"
            dark
          >
            <i class="fab fa-facebook"></i>
          </v-btn>
          <div class="newnotifycount" v-if="facebooknotify && isTicketAdmin">
            {{ facebooknotify }}
          </div>
        </v-flex>
      </template>
      <!-- <v-flex style="position: relative">
        <v-btn
          depressed
          style="border-radius: 0; width: 100%"
          class="ma-0 pa-0"
          :color="$store.state.livechat.app == 'line' ? 'primary' : 'grey'"
          @click="changeApp('line')"
          dark
        >
          <i class="fab fa-line"></i>
        </v-btn>
        <div class="newnotifycount px-1" style="width:auto" v-if="linenotify && isTicketAdmin">
          {{ linenotify }}
        </div>
      </v-flex> -->
      <!-- <v-flex>
        <v-btn
          depressed
          style="border-radius: 0; width: 100%; position: relative; height: 100%"
          class="ma-0 pa-0"
          @click="$emit('onsearch', true)"
        >
          <v-icon>search</v-icon>
        </v-btn>
      </v-flex> -->
    </v-layout>
    <div style="position: relative;">
      <!-- <template v-if="currentLivechatExpireTime > 0">
        <div class="px-1 info caption white--text">
          แพคเกจรวมแชทคงเหลือ
          <countdown :time="currentLivechatExpireTime * 1000">
            <template slot-scope="props">
              <template v-if="props.days">
                {{ props.days | numberFormat }}
                <span class="small">{{ $t('Days') }}</span>
              </template>
              <template v-else-if="props.hours > 0">
                {{ props.hours | numberFormat }}
                <span class="small">{{ $t('Hours') }}</span>
              </template>
              <template v-else-if="props.minutes > 0">
                {{ props.minutes | numberFormat }}
                <span class="small">{{ $t('Minutes') }}</span>
              </template>
              <template v-else>
                {{ props.seconds | numberFormat }}
                <span class="small">{{ $t('Seconds') }}</span>
              </template>
            </template>
          </countdown>
        </div>
      </template> -->
      <!-- tab admin -->
      <v-tabs
        id="usertype"
        color="white"
        :value="admin"
        :slider-color="'#ffffff'"
        @change="changeType"
      >
        <!-- :slider-color="$vuetify.theme.primary" -->
        <!-- :value="$store.state.livechat.type" คือ value เก่าสำหรับสลับ bot กับ admin-->
        <!-- pointer-events: none; -->
        <v-tab
          ripple
          :key="'admin'"
          :href="'#admin'"
          style="height: 48px; pointer-events: none;  position: relative; padding-left: 25px; padding-top: 11px; padding-bottom: 10px;"
        >
          <div style="border-bottom: 1px solid #0C2F53;">
            {{ $t('Admin') + ' ' + AdminID }}
            <!-- <div
              class="newnotifycount"
              v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0' && isTicketAdmin"
            >
              {{ chatnotify.admin }}
            </div> -->
          </div>
        </v-tab>
        <!-- <v-tab ripple :key="'bot'" :href="'#bot'" style="position: relative">
          <div>
            {{ $t('chatbot') }}
            <div
              class="newnotifycount px-1"
              style="width:auto"
              v-if="chatnotify && chatnotify.bot && chatnotify.bot != '0' && isTicketAdmin"
            >
              {{ chatnotify.bot }}
            </div>
          </div>
        </v-tab> -->

        <v-spacer></v-spacer>

        <!-- <v-btn
          right
          depressed
          style="border-radius: 0; width: 24px; position: relative; height: 100%"
          color="white"
          class="ma-0 pa-0"
          @click="$emit('onsearch', true)"
        >
          <v-icon color='#BDBDBD'>search</v-icon>
        </v-btn> -->

        <!-- ปุ่มค้นหา -->
        <v-icon
          right
          depressed
          style="border-radius: 0; width: 24px; position: relative; height: 100%; display: flex; flex-direction: column;
            justify-content: center; align-items: center;"
          class="ma-0 pa-0"
          @click="$emit('onsearch', true)"
          color="#BDBDBD"
          >search</v-icon
        >

        <!-- <v-btn
        right
        depressed
        style="border-radius: 0; width: 24px; position: relative; height: 100%"
        color="white"
        class="ma-0 pa-0"
      >
        <v-icon color='#BDBDBD'>mdi-dots-vertical</v-icon>
      </v-btn> -->

        <!-- ปุ่มตัวเลือก อ่านแล้ว/ยังไม่ได้อ่าน-->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              right
              depressed
              style="border-radius: 0; width: 24px; position: relative; height: 100%; display: flex; flex-direction: column;
                  justify-content: center; align-items: center; padding-right: 19px;"
              class="ma-0 pa-0"
              color="#BDBDBD"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list
            style="background: none; box-shadow: none !important; display: flex; flex-direction: column;"
          >
            <!-- border: 1px solid #0C2F53; border-radius: 8px; -->
            <div
              depressed
              class="hover"
              @click="ReadFilter()"
              style="display: flex; justify-content: center; align-items: center; background: white; 
          border: 1px solid #0C2F53; border-top-right-radius: 8px; border-top-left-radius: 8px; padding-bottom: 8px; cursor: pointer;
          border-bottom: none; padding-top: 8px; padding-left: 42px; padding-right: 42px;"
            >
              {{ 'อ่านแล้ว' }}
              <v-icon v-if="isRead">mdi-check</v-icon>
            </div>
            <div
              depressed
              class="hover"
              @click="UnReadFilter()"
              style="display: flex; justify-content: center; align-items: center; background: white; 
          border: 1px solid #0C2F53; border-bottom-right-radius: 8px; border-bottom-left-radius: 8px; padding-bottom: 8px; cursor: pointer;
          padding-top: 8px; padding-left: 42px; padding-right: 42px;"
            > 
              {{ 'ยังไม่ได้อ่าน' }}
              <v-icon v-if="isUnread">mdi-check</v-icon>
            </div>
          </v-list>
        </v-menu>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from './event-bus.js'
import moment from 'moment'
export default {
  props: {
    newchatnotify: { type: Object },
    AdminID: { type: String } //localStorage.getItem('userid')
  },
  data() {
    return {
      isRead: false,
      isUnread: false,
    }
  },
  mounted() {
    // console.log = localStorage.getItem('userid')
    localStorage.setItem('ReadFilter', false)
    localStorage.setItem('UnReadFilter', false)
  },
  computed: {
    isTicketAdmin() {
      if (this.selectedBot.theme == 'ticket') {
        return (
          !this.$store.state.privilege.view_ticket ||
          this.$store.state.privilege.view_ticket == 'all'
        )
      } else return true
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching'
    }),
    currentLivechatExpireTime() {
      var bot = this.botlist.find(el => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (bot && bot.livechat_expireat != null) {
        var now = moment()
        var date = moment(bot.livechat_expireat)
        return parseInt(now.diff(date, 'seconds'))
      } else return null
    },
    chatnotify() {
      if (this.$store.state.livechat.app == 'facebook')
        return {
          admin: this.newchatnotify.facebook_admin,
          bot: this.newchatnotify.facebook_bot
        }
      else if (this.$store.state.livechat.app == 'line')
        return {
          admin: this.newchatnotify.line_admin,
          bot: this.newchatnotify.line_bot
        }
    },
    facebooknotify() {
      if (this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin) {
        return (
          parseFloat(this.newchatnotify.facebook_bot) +
          parseFloat(this.newchatnotify.facebook_admin)
        )
      } else return ''
    },
    linenotify() {
      if (this.newchatnotify.line_bot || this.newchatnotify.line_admin) {
        return parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
      } else return ''
    }
  },
  methods: {
    ReadFilter() {
      if(this.isRead){
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        localStorage.setItem('ReadFilter', false)
        localStorage.setItem('UnReadFilter', false)
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        eventBus.$emit('ReadFilterOrUnread-event')
      }
      else{
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        localStorage.setItem('ReadFilter', true)
        localStorage.setItem('UnReadFilter', false)
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        eventBus.$emit('ReadFilterOrUnread-event')
      }
      this.isRead = !this.isRead
      this.isUnread = false
    },
    UnReadFilter() {

      if(this.isUnread){
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        localStorage.setItem('ReadFilter', false)
        localStorage.setItem('UnReadFilter', false)
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        eventBus.$emit('ReadFilterOrUnread-event')
      }
      else{
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        localStorage.setItem('ReadFilter', false)
        localStorage.setItem('UnReadFilter', true)
        console.log(localStorage.getItem('ReadFilter'), localStorage.getItem('UnReadFilter'))
        eventBus.$emit('ReadFilterOrUnread-event')
      }
      this.isUnread = !this.isUnread
      this.isRead = false
    },
    changeApp(type) {
      // this.$store.commit('SET_LIVECHAT_APP', type)
      this.$store.commit('SET_LIVECHAT_APP', 'line')
      this.$store.dispatch('updateLivechatUser', null)

      this.updateRoute()
    },
    changeType(name) {
      // debugger
      this.$store.commit('SET_LIVECHAT_TYPE', name)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    updateRoute: function() {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  }
}
</script>

<style lang="scss" scoped>
.hover:hover {
  background-color: rgba(238, 238, 238, 1); /* เปลี่ยนเป็นสีแดง */
}

div .v-menu__content {
  /* กำหนด CSS property ที่ต้องการให้กับ .v-menu__content */
  background-color: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTab.vue